import type { IUser } from 'store/declare';

/** Таймер обновления состояния "Говорит" */
let timer: number;
/** Флаг - в данный момент происходит обновление состояния */
let isOnProcess = false;
/** Предыдущее значение состояния "Говорит" */
let previousState = false;

/** Получить функцию обновления состояния "Говорит" у текущего пользователя */
export function getCurrentUserIsTalkingStateUpdater(setCurrentUser: React.Dispatch<React.SetStateAction<IUser | null>>) {
    return (isTalking: boolean) => {
        // Когда пользователь начинает говорить - моментально устанавливаем соответствующее состояние
        if (isTalking) {
            isOnProcess = true;

            setCurrentUser(prevState => {
                if (prevState && !prevState.isTalking) {
                    return { ...prevState, isTalking: true };
                }

                return prevState;
            });
            previousState = true;
            isOnProcess = false;

            return;
        }

        // Когда пользователь перестает говорить - меняем соответствующее состояние через интервал
        if (!isOnProcess && previousState !== isTalking) {
            previousState = false;
            isOnProcess = true;
            window.clearTimeout(timer);
            timer = window.setTimeout(() => {
                setCurrentUser(prevState => {
                    if (prevState && prevState.isTalking) {
                        return { ...prevState, isTalking: false };
                    }

                    return prevState;
                });
                isOnProcess = false;
            }, 1500);
        }
    };
}
